import { FullscreenModalConfig } from './fullscreen-modal-config';
export const DEFAULT_CONFIG: FullscreenModalConfig = {
  hasBackdrop: true,
  width: '100%',
  height: '100%',
  modalOrigin: 'right'
};
